import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Loading } from 'Shared/components';
import { DEFAULT_LOADING_LABEL } from 'Common/consts';
import NoLevelResultsData from 'Common/components/NoLevelResultsData/NoLevelResultsData';
import { useStatistic } from 'Common/hooks';
import { ELoadingStatus } from 'API/types';
import useRouter from 'Router/index';
import { getLoadingMessage, getDataExists, getIsEmpty, getCommonLoadingStatus, getCommonErrorType, } from 'PhenotypeView/store/selectors';
import { getErrorMessage } from 'PhenotypeView/utils';
import { useValidatedPhenotypeId } from 'PhenotypeView/hooks';
const TabContentWrapper = ({ levelResult, children, }) => {
    const dataExists = useSelector(getDataExists);
    const isEmpty = useSelector(getIsEmpty);
    const loadingMessage = useSelector(getLoadingMessage);
    const loadingStatus = useSelector(getCommonLoadingStatus);
    const errorType = useSelector(getCommonErrorType);
    const { getParams } = useRouter();
    const { datasetVersionId } = getParams();
    const phenotypeId = useValidatedPhenotypeId();
    /**
     * Recreate routeParams to avoid redundant updates
     */
    const routeParams = useMemo(() => ({
        phenotypeId,
        datasetVersionId,
        levelResult,
    }), [phenotypeId, datasetVersionId, levelResult]);
    useStatistic(routeParams);
    if (loadingStatus === ELoadingStatus.Loading) {
        // Show fullscreen loading message until `dataExists` flag would be set
        return (_jsx(Loading, { message: loadingMessage, fullScreen: !dataExists, label: DEFAULT_LOADING_LABEL }, void 0));
    }
    if (errorType === 1 /* EmptyData */) {
        return (_jsx(NoLevelResultsData, { message: getErrorMessage(levelResult, true) }, void 0));
    }
    if (isEmpty) {
        return null;
    }
    return (_jsx(_Fragment, { children: children }, void 0));
};
export default TabContentWrapper;
